import { gql } from 'apollo-angular';

/**
 * User schema
 */
export class AuthSchema {
	/**
	 * Get full company data via User
	 */
	static readonly isUsersSession = gql`
		query isUsersSession($sessionId: ID!) {
			isUsersSession(sessionId: $sessionId)
		}
	`;
}
